/**
 * Does not include - and ' because can be included in name
 * @param {string} value Value to test for symbols & digits in first name/second name
 */
const nameHasDigitsOrSymbols = (name) =>
  /[!@#$%\\/|^&*,.?(){}+=`~_:;"\\[\]]|\d/g.test(name);

/**
 * Format to have thousands separator
 * @param {string} value Value to format
 */
const thousandsSeparator = (value) => value.toLocaleString("en");

export { nameHasDigitsOrSymbols, thousandsSeparator };
